import { toggleMarkWithAttrs, isCustomMarkActive } from "../../../commands/custom-commands";
import { customSchema } from "../../../schemas/custom-schema";

export default class UnderlineButton {
	constructor(editorView, containerElement) {
		this.view = editorView;
		this.buttonElement = document.createElement("button");
		this.buttonElement.setAttribute("type", "button");
		this.buttonElement.className = "editor-toolbar-button";
		this.buttonElement.setAttribute("type", "button");
		this.buttonElement.dataset.action = "underline";
		this.buttonElement.title = "Subrayado";
		const iconSpan = document.createElement("span"),
			labelSpan = document.createElement("span");
		iconSpan.textContent = "Subrayado";
		labelSpan.className = "oculto-visual";
		labelSpan.textContent = "Subrayado";
		this.buttonElement.appendChild(iconSpan);
		this.buttonElement.appendChild(labelSpan);

		this.action = this.buttonClickCallback();
		this.rejectFocusAction = this.buttonMouseDownCallback();
		this.buttonElement.addEventListener("click", this.action);
		this.buttonElement.addEventListener("mousedown", this.rejectFocusAction);
		containerElement.appendChild(this.buttonElement);
		this.update(editorView);
	}

	update(view) {
		const isActive = isCustomMarkActive(view.state, customSchema.marks.underline) ? "true" : "false",
			isEnabled = toggleMarkWithAttrs(customSchema.marks.underline)(view.state, null);
		this.buttonElement.setAttribute("aria-pressed", isActive);
		this.buttonElement.disabled = !isEnabled;
		this.view = view;
	}

	destroy() {
		this.buttonElement.removeEventListener("click", this.action);
		this.buttonElement.removeEventListener("mousedown", this.rejectFocusAction);
		this.buttonElement.remove();
		this.buttonAction = null;
		this.rejectFocusAction = null;
		this.buttonElement = null;
		this.view = null;
	}

	buttonMouseDownCallback() {
		return (event) => {
			event.preventDefault();
		}
	}

	buttonClickCallback() {
		return () => {
			toggleMarkWithAttrs(customSchema.marks.underline)(this.view.state, this.view.dispatch);
		}
	}
}